(function(){
  function fmt(c){return (c/100).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2});}
  document.querySelectorAll('[data-bsai-cmp]').forEach(function(root){
    var chks=root.querySelectorAll('.bsai-cmp__chk'),tot=root.querySelector('[data-bsai-total]'),
        cnt=root.querySelector('[data-bsai-count]'),btn=root.querySelector('[data-bsai-add]'),msg=root.querySelector('[data-bsai-msg]');
    function sel(){return Array.prototype.filter.call(chks,function(c){return c.checked;});}
    function upd(){var s=sel(),t=0;s.forEach(function(c){t+=+c.dataset.price;});tot.textContent=fmt(t);
      cnt.textContent='('+s.length+(s.length===1?' producto)':' productos)');
      btn.textContent=s.length===1?'Agregar al carrito':(s.length===chks.length?'Agregar todo al carrito':'Agregar '+s.length+' productos al carrito');}
    chks.forEach(function(c){c.addEventListener('change',upd);});
    root.addEventListener('click',function(e){if(e.target.closest('a.bsai-cmp__name'))e.stopPropagation();});
    btn.addEventListener('click',function(){
      var items=sel().map(function(c){return {id:+c.dataset.id,quantity:1};});
      btn.disabled=true;msg.textContent='';
      var drawer=document.querySelector('cart-drawer');
      var body={items:items};
      if(drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id;});body.sections_url=window.location.pathname;}
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(j){
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        if(drawer&&drawer.renderContents){drawer.renderContents(j);if(drawer.open)drawer.open();}
        else{window.location.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart';}
      })
      .catch(function(err){msg.textContent=(err&&err.description)||'No fue posible agregar los productos. Por favor intente de nuevo.';})
      .finally(function(){btn.disabled=false;});
    });
    upd();
  });
})();
